import React, { useEffect, useState } from "react";
import logo from "../../assets/brand/logo_background.png";
import navData from "../../assets/data/navData.js";
import classes from "./navbar.module.scss";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";

import ListIcon from "@mui/icons-material/List";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { userActions } from "../../store/userSlice.js";
import Overlay from "../../generic components/overlay/Overlay.js";
import SpecialRequest from "../../pages/home/specialRequest/SpecialRequest.js";
import { trackEvent } from "../../utils/analytics.js";

const NavBar = (props) => {
  const user = useSelector((state) => state.user);
  const [dropDown, setDropDown] = useState(false);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const logged = user.loggedIn;

  const location = useLocation();

  const dispatch = useDispatch();

  const isAdminRoute = location.pathname.includes("/admin");
  const isProfileRoute = location.pathname.includes("/profile");
  const isBlogseRoute = location.pathname.includes("/blogs/");

  function handleLogout() {
    dispatch(userActions.logout());
    setDropDown(false);
  }

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll(); // run once on mount
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <nav
        id="intro"
        className={`${classes.navHome}
        ${scrolled && classes.is_scrolled} 
        ${(isBlogseRoute || isProfileRoute) && classes.capacity_navbar}
        ${isAdminRoute && classes.admin_navbar}`}
      >
        {!isAdminRoute && (
          <Link to="/">
            <div className={classes.logoContainer}>
              <img className={classes.logo} src={logo} alt="logo" />
            </div>
          </Link>
        )}

        <div className={classes.routes}>
          <ul className={classes.nav_list}>
            {isAdminRoute && (
              <div className={classes.list}>
                <li className={classes.navItem}>
                  <NavLink to={"/"}>
                    <div className={classes.wrapper}>
                      <div>Back to home</div>
                    </div>
                  </NavLink>
                </li>
              </div>
            )}

            {!isAdminRoute &&
              navData.Home[0].map((element, index) => {
                return (
                  <>
                    <div className={classes.list} key={index}>
                      <li
                        className={`${classes.navItem} ${
                          element.isHighlighted && classes.is_highlighted
                        }`}
                      >
                        <NavLink
                          className={({ isActive }) =>
                            isActive ? classes.active_class : ""
                          }
                          to={element.route}
                        >
                          <div className={classes.wrapper}>
                            {element.icon}
                            <div>{element.title}</div>
                          </div>
                        </NavLink>
                        <ul className={classes.dropdown}>
                          {element.children &&
                            element.children.map((child, idx) => (
                              <li key={idx} className={classes.dropdown__item}>
                                <Link
                                  to={child.route}
                                  className={classes.dropdown__item__link}
                                >
                                  {child.title}
                                </Link>
                              </li>
                            ))}
                        </ul>
                      </li>
                    </div>
                  </>
                );
              })}

            {!isAdminRoute && (
              <div
                className={classes.list}
                onClick={() => {
                  trackEvent({
                    event: "special_request_open",
                    facebookEvent: "Lead",
                    payload: { source: "navbar" },
                  });
                  setOpen(true);
                }}
              >
                <li className={classes.navItem}>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? classes.active_class : ""
                    }
                  >
                    <div className={classes.wrapper}>
                      <div>Special REQ & B2B</div>
                    </div>
                  </NavLink>
                </li>
              </div>
            )}
            {logged && (
              <>
                {user.isAdmin && !isAdminRoute && (
                  <div className={classes.list}>
                    <li className={classes.navItem}>
                      <Link to={"/admin/dashboard"}>
                        <div className={classes.wrapper}>
                          <div>Admin Center</div>
                        </div>
                      </Link>
                    </li>
                  </div>
                )}
                {!user.isAdmin && (
                  <>
                    <div className={classes.list}>
                      <li className={classes.navItem}>
                        <Link to={"/profile/" + user.id + "?tab=Wishlist"}>
                          <div className={classes.wrapper}>
                            <FavoriteBorderIcon className={classes.fav} />
                          </div>
                        </Link>
                      </li>
                    </div>
                    <div className={classes.list}>
                      <li className={classes.navItem}>
                        <Link to={"/profile/" + user.id + "?tab=Profile+Info"}>
                          <div className={classes.wrapper}>
                            <PersonOutlineIcon
                              className={classes.profile}
                              sx={{ fontSize: "2.4rem" }}
                            />
                          </div>
                        </Link>
                      </li>
                    </div>
                  </>
                )}

                <div className={classes.list}>
                  <li className={classes.navItem}>
                    <Link onClick={() => handleLogout()} to="/login">
                      <div className={classes.wrapper}>
                        <LogoutIcon sx={{ fontSize: "2rem" }} />
                      </div>
                    </Link>
                  </li>
                </div>
              </>
            )}
            {!logged && (
              <NavLink to="/login">
                <button className={classes.btn}>
                  Sign In <TrendingFlatIcon sx={{ fontSize: "2rem" }} />
                </button>
              </NavLink>
            )}
          </ul>
        </div>

        {/* mobile view */}
        <ListIcon
          className={classes.burger}
          onClick={() => setDropDown(!dropDown)}
        />
        {dropDown && (
          <ul className={classes.dropDown}>
            {navData.Home[0].map((item, index) => {
              return (
                <li
                  key={index}
                  className={classes.navSubItem}
                  onClick={() => setDropDown(false)}
                >
                  <NavLink
                    to={item.route}
                    className={classes.navTitle}
                    activeClassName={classes.activeLink}
                  >
                    {item.title}
                  </NavLink>
                </li>
              );
            })}
            {!logged ? (
              <li
                className={classes.navSubItem}
                onClick={() => setDropDown(false)}
              >
                <NavLink
                  to={navData.Home[1][0].route}
                  className={classes.navTitle}
                  activeClassName={classes.activeLink}
                >
                  {navData.Home[1][0].title}
                </NavLink>
              </li>
            ) : user.isAdmin ? (
              navData.Home[3].map((item, index) => {
                return (
                  <li
                    className={classes.navSubItem}
                    onClick={
                      item.title === "Log Out"
                        ? () => handleLogout()
                        : () => {
                            setDropDown(false);
                          }
                    }
                  >
                    <NavLink
                      to={
                        item.title === "Profile"
                          ? "/profile/" + user.id
                          : item.route
                      }
                      className={classes.navTitle}
                    >
                      {item.title}
                    </NavLink>
                  </li>
                );
              })
            ) : (
              navData.Home[2].map((item, index) => {
                return (
                  <li
                    className={classes.navSubItem}
                    onClick={
                      item.title === "Log Out"
                        ? () => handleLogout()
                        : () => {
                            setDropDown(false);
                          }
                    }
                  >
                    <NavLink
                      to={
                        item.title === "Profile"
                          ? "/profile/" + user.id
                          : item.route
                      }
                      className={classes.navTitle}
                    >
                      {item.title}
                    </NavLink>
                  </li>
                );
              })
            )}
          </ul>
        )}
      </nav>
      <SpecialRequest setOpen={setOpen} open={open} />
    </>
  );
};

export default NavBar;
